import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DashboardService} from '../dashboard.service';
import {Location} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {UtilsService} from '../../core/services/utils/utils.service';
import {ApiService} from '../../core/http/api.service';

@Component({
    selector: 'app-edit-user-details',
    templateUrl: './edit-user-details.component.html',
    styleUrls: ['./edit-user-details.component.css'],
    standalone: false
})

export class EditUserDetailsComponent implements OnInit {
  userId = '';
  scoreModels = [];
  user: any;
  loading = false;
  uploading = false;

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private api: ApiService,
    private utils: UtilsService,
    private _location: Location,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.getCurrentUserData();
  }

  getCurrentUserData(): void {
    this.route.params.subscribe(params => this.userId = params.id);
    this.dashboardService.getUserDataById(this.userId).subscribe((data) => {
      const response = {...data};
      this.getAllScoreModels(response?.scoreModels || []);
      delete response?.scoreModels;
      this.user = data;
    });
  }

  getAllScoreModels(prevData = []): void {
    this.api.getAllScoreModels({}).subscribe((data) => {
      const response = data.response?.data || [];
      const criterion = [];
      response.map(item => {
        item.criterion?.map(subItem => {
          const findPrevData = prevData?.find(val => val.fieldSlug === subItem?.criteriaSlug);
          criterion.push({
            fieldLabel: subItem?.criteriaName,
            fieldSlug: subItem?.criteriaSlug,
            fieldValue: findPrevData?.fieldValue || ''
          });
        });
        this.scoreModels = criterion;
      });
    });
  }

  updateUser(): any {
    this.loading = true;
    // tslint:disable-next-line:max-line-length
    this.user.canManageUnclaimedUserActivity = !(this.user.canManageUnclaimedUserActivity === 'false' || this.user.canManageUnclaimedUserActivity === false);

    const payload = {...this.user};
    if (this.scoreModels?.length) {
      payload.scoreFields = this.scoreModels.map(item => {
        return {...item, fieldValue: Number(item.fieldValue || 0)};
      });
    }

    this.dashboardService.updateUser(this.user?.id, payload).subscribe((data) => {
      this.loading = false;
      this.getCurrentUserData();
      this.toastr.success('User details updated');
      this.goBack();
    }, err => {
      this.toastr.error(err.error.message);
      this.loading = false;
    });
  }

  goBack(): void {
    this._location.back();
  }

  uploadImage(event): void {
    this.uploading = true;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.dashboardService.uploadImage({file: reader.result}).subscribe(res => {
          this.user.profile = res.response.url;
          this.uploading = false;
        },
        err => {
          this.utils.resErr(err);
          this.uploading = false;
        });
    };
  }

  handleClickUpload(): void {
    const ele = document.getElementById('dp');
    if (!!ele) {
      ele.click();
    }
  }
}
